import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArmchair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"armchair, seat, chill"} maskId="square-filled-radius-0-stroke-1-IconArmchair"><path d="M5 11V3H19V11H16V14H8V11H5Z" fill="currentColor"/><path d="M3 12V19H5V21H6V19H18V21H19V19H21V12H17V15H7V12H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArmchair;
